/**
 * Reload current page.
 */
export const reloadPage = () => window.location.reload();

/**
 * Navigate to new path in URL.
 */
export const navigateToPath = (path: string) => {
    window.location.href = path;
};

/**
 * Navigate to new search part of the URL.
 */
export const navigateToSearch = (search: string) => {
    window.location.search = search;
};

/**
 * Check if pathname is included in current window location
 */
export const pathnameIncludes = (pathname: string): boolean => window.location.pathname.includes(pathname);

/**
 * Checks if the href matches certain regular expression
 * @param match
 */
export const hrefMatches = (match: RegExp): boolean => !!window.location.href.match(match);

/**
 * Redirect to location if it is different from a current one
 */
export const softRedirect = (pathname: string): void => {
    if (!window.location.href.includes(pathname)) {
        window.location.assign(pathname);
    }
};

export default {
    hrefMatches,
    navigateToPath,
    pathnameIncludes,
    reloadPage,
    softRedirect,
};
